import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import { Switch } from "react-router-dom";
import StickySidebar from "./layouts/StickySidebar";
import Dashboard from "./dashboard/MainDashboard";
// import Customers from "./customers/Index";
// import AddCustomer from "./customers/add-customer";
// import EditCustomer from "./customers/edit-customer";
// import Expenses from "./finance-accounts/expenses/expenses";
// import AddExpenses from "./finance-accounts/expenses/add-expenses";
// import EditExpenses from "./finance-accounts/expenses/edit-expenses";
// import RecurringInvoice from "./sales/invoices/recurring";
// import AddPurchaseReturn from "./purchases-component/purchases/add-purchase-return";
// import Calendar from "./main/application/calendar";
// import DomainRequest from "./main/superadmin/domainrequest";
// import Packages from "./main/superadmin/packages";
// import Subscription from "./main/superadmin/subscription";
// import FontAwesome from "./ui-interface/icons/font-awesome";
// import Feather from "./ui-interface/icons/feather";
// import IconicIcon from "./ui-interface/icons/iconic";
// import MaterialIcons from "./ui-interface/icons/material";
// import Pe7 from "./ui-interface/icons/pe7";
// import Invoices from "./sales/invoices/Index";
// import Invoicedetails from "./sales/invoices/Invoice-details";
// import ViewInvoice from "./sales/invoices/view-invoice";
// import AddInvoice from "./sales/invoices/AddInvoice";
// import EditInvoice from "./sales/invoices/edit-invoice";
// import InvoicePaid from "./sales/invoices/Invoice-paid";
// import ParticallyPaid from "./sales/invoices/partically-paid";
// import InvoiceUnpaid from "./sales/invoices/Invoice-unpaid";
// import RefundedInvoice from "./sales/invoices/refunded-Invoice";
// import InvoiceOverdue from "./sales/invoices/Invoice-overdue";
// import Invoicesettings from "./sales/invoices/Invoice-settings";
// import InvoiceDraft from "./sales/invoices/Invoice-draft";
// import Invoicecancelled from "./sales/invoices/Invoice-cancelled";
// import Chat from "./main/application/chat";
// import Alert from "./ui-interface/base-ui/alerts";
// import Accordions from "./ui-interface/base-ui/accordions";
// import Avatar from "./ui-interface/base-ui/avatar";
// import Badges from "./ui-interface/base-ui/badges";
// import Buttons from "./ui-interface/base-ui/buttons";
// import Buttongroup from "./ui-interface/base-ui/button-group";
// import Breadcrumbs from "./ui-interface/base-ui/breadcrumbs";
// import Cards from "./ui-interface/base-ui/cards";
// import Carousel from "./ui-interface/base-ui/carousel";
// import Dropdowns from "./ui-interface/base-ui/dropdowns";
// import Grid from "./ui-interface/base-ui/grid";
// import Images from "./ui-interface/base-ui/images";
// import Lightbox from "./ui-interface/base-ui/lightbox";
// import Media from "./ui-interface/base-ui/media";
// import Modals from "./ui-interface/base-ui/modals";
// import Offcanvas from "./ui-interface/base-ui/offcanvas";
// import Pagination from "./ui-interface/base-ui/pagination";
// import Popover from "./ui-interface/base-ui/popover";
// import Progress from "./ui-interface/base-ui/progress";
// import Placeholder from "./ui-interface/base-ui/placeholders";
// import RangeSlides from "./ui-interface/base-ui/rangeslider";
// import Spinners from "./ui-interface/base-ui/spinners";
// import Sweetalerts from "./ui-interface/base-ui/sweeetalerts";
// import Tap from "./ui-interface/base-ui/tab";
// import Toasts from "./ui-interface/base-ui/toasts";
// import Tooltip from "./ui-interface/base-ui/tooltip";
// import Typography from "./ui-interface/base-ui/typography";
// import Videos from "./ui-interface/base-ui/videos";
// import Ribbon from "./ui-interface/elements/ribbon";
// import DragDrop from "./ui-interface/elements/drag&drop";
// import Rating from "./ui-interface/elements/rating";
// import Texteditor from "./ui-interface/elements/texteditor";
// import Counter from "./ui-interface/elements/counter";
// import Scrollbar from "./ui-interface/elements/scrollbar";
// import Stickynote from "./ui-interface/elements/stickynote";
// import Timeline from "./ui-interface/elements/timeline";
// import Horizontaltimeline from "./ui-interface/elements/horizontaltimeline";
// import Formwizard from "./ui-interface/elements/formwizard";
// import { Clipboard } from "./ui-interface/elements/clipboard";
// import InvoiceOnea from "./sales/invoices/invoice-one-a";
// import InvoiceFourA from "./sales/invoices/invoice-four-a";
// import Companies from "./main/superadmin/companies";

// import ContactMessage from "./support/contactMessage";
// import customersLedger from "./customers/customersLedger";
// import BankSetting from "./settings/BankSetting";
// import PaymentMethod from "./settings/PaymentMethod";
// import Error404 from "./pages/error404";
// import DeleteAccounts from "./settings/deleteAccount";
// import VectorMaps from "./pages/vectormaps/Index";
// import TypiconIcons from "./ui-interface/icons/typicon";
// import SimpleLine from "./ui-interface/icons/simpleLine";
// import Themify from "./ui-interface/icons/themify";
// import WeatherIcons from "./ui-interface/icons/weather";
// import Flags from "./ui-interface/icons/flags";
// import Apexchart from "./ui-interface/charts/apexcharts";
// import ChartJs from "./ui-interface/charts/chartjs";
// import Tickets from "./support/tickets";
// import TicketRecurring from "./support/tickets/ticketRecurring";
// import TicketCancelled from "./support/tickets/ticketCancelled";
// import TicketList from "./support/tickets/ticketlist";
// import TicketListPending from "./support/tickets/ticketlist/ticketListPending";
// import TicketListOverdue from "./support/tickets/ticketlist/ticketListOverdue";
// import TicketListDraft from "./support/tickets/ticketlist/ticketListdraft";
// import TicketListRecurring from "./support/tickets/ticketlist/ticketListRecurring";
// import TicketListCancelled from "./support/tickets/ticketlist/ticketListCancelled";
// import TicketKanban from "./support/tickets/ticketKanban";
// import TicketDetails from "./support/tickets/ticketOverview";
// import AddMembership from "./membership/addMembership";
// import EditTestimonials from "./content/testimonials/editTestimonials";
// import AddTestimonials from "./content/testimonials/addTestimonials";
// import Faq from "./content/faq";
// import Cities from "./content/location/cities";
// import States from "./content/location/states";
// import Countries from "./content/location";
// import BlogComments from "./content/blog/blog-comments";
// import AddCategories from "./content/blog/add-categories";
// import Categories from "./content/blog/categories";
// import AddBlog from "./content/blog/add-blog";
// import InactiveBlog from "./content/blog/inactive-blog";
// import AllBlogs from "./content/blog/blog";
// import Testimonials from "./content/testimonials";
// import Pages from "./pages/page";
// import AddPage from "./pages";
// import Transaction from "./membership/transaction";
// import Payments from "./finance-accounts/payments/payments";
// import AccountSettings from "./settings/AccountSettings";
// import CompanySettings from "./settings/CompanySettings";
// import InvoiceSetting from "./settings/InvoiveSetting";
// import InvoiceTemplateSettings from "./settings/InvoiceTemplateSettings";
// import Inbox from "./main/application/inbox";
// import RecurringHead from "./sales/invoices/recurring/recurringHead";
// import CreditPending from "./sales/creditNotes/creditPending";
// import CreditOverdue from "./sales/creditNotes/creditOverdue";
// import CreditDraft from "./sales/creditNotes/creditDraft";
// import CreditRecurring from "./sales/creditNotes/creditRecurring";
// import CreditCancelled from "./sales/creditNotes/creditCancelled";
// import AddCredit from "./sales/creditNotes/addCredit";
// import CreditDetails from "./sales/creditNotes/creditDetails";
// import Purchases from "./purchases-component/purchases/purchases";
// import AddPurchases from "./purchases-component/purchases/add-purchases";
// import EditPurchase from "./purchases-component/purchases/edit-purchases";
// import PurchaseDetails from "./purchases-component/purchases/purchase-details";
// import PurchaseOrders from "./purchases-component/purchases/purchase-orders";
// import DebitNotes from "./purchases-component/purchases/debit-notes";
// import Quotations from "./quotation-component/quotations";
// import AddQuotations from "./quotation-component/quotations/addQuotations";
// import EditQuotations from "./quotation-component/quotations/editQuotations";
// import DeliveryChallans from "./quotation-component/deliveryChallans";
// import EditChallans from "./quotation-component/deliveryChallans/editChallans";
// import AddChallans from "./quotation-component/deliveryChallans/addChallans";
// import PaymentSummary from "./reports-component/paymentSummary";
// import AddUser from "./user-management/manageUser";
// import Users from "./user-management/manageUser/user";
// import EditUser from "./user-management/manageUser/editUser";
// import RolesPermission from "./user-management/rolePermission";
// import Permission from "./user-management/rolePermission/permission";
// import DeleteAccount from "./user-management/deleteAccount";
// import MembershipPlan from "./membership";
// import MembershipAddons from "./membership/membershipAddons";
// import Subscribers from "./membership/subscribers";
// import BasicInputs from "./ui-interface/forms/basic-inputs";
// import FormInputGroups from "./ui-interface/forms/input-groups";
// import HorizontalForm from "./ui-interface/forms/horizontal-form";
// import VerticalForm from "./ui-interface/forms/vertical-form";
// import FormMask from "./ui-interface/forms/FormMask";
// import FormValidation from "./ui-interface/forms/FormValidation";
// import Fileupload from "./ui-interface/forms/File-upload";
// import Formselect2 from "./ui-interface/forms/form-select2";
// import BasicTables from "./ui-interface/tables/BasicTables";
// import Datatables from "./ui-interface/tables/DataTables";
import Login from "./authentication/Login";
// import Register from "./authentication/Register";
// import ForgotPassword from "./authentication/forgot-password";
// import LockScreen from "./authentication/lock-screen";
// import AddProduct from "./inventory/products/addProduct";
// import EditProduct from "./inventory/products/editProduct";
// import ActiveCustomers from "./customers/activeCustomers";
// import DeactiveCustomers from "./customers/deactivateCustomers";
// import CustomerDetails from "./customers/customerDetails";
// import Vendors from "./customers/vendors";
// import ProductList from "./inventory/products/productList";
// import Units from "./inventory/products/units";
// import Inventory from "./inventory";
// import InvoiceList from "./sales/invoices/invoice-list";
// import InvoiceTemplate from "./sales/invoices/invoice-template";
// import InvoiceDetailsAdmin from "./sales/invoices/Invoice-details-admin";
// import Category from "./inventory/products/category";
// import Components from "./components/Index";
// import SalesReport from "./reports-component/reports/salesreport";
// import ExpenseReport from "./reports-component/reports/expense";
// import ProfitlossReport from "./reports-component/reports/profitloss";
// import Taxreport from "./reports-component/reports/taxreport";

// import EmailSettings from "./settings/EmailSettings";
// import ExpenseCategory from "./settings/ExpenseCategory";
// import Notifications from "./settings/Notifications";
// import ChangePassword from "./settings/ChangePassword";
import Profile from "./profile/Index";
import ProfileSettings from "./profile/ProfileSettings";

import ChangePassword from "./profile/ChangePassword";




// import Page404 from "./pages/errorpages/404";
// import Page500 from "./pages/errorpages/500";
// import BlankPage from "./pages/blank-page";
// import CreditNotes from "./sales/creditNotes";
// import Domain from "./main/superadmin/domain";
// import PurchaseTransaction from "./main/superadmin/purchase-transaction";
// import AddPurchaseOrder from "./purchases-component/purchases/add-purchase-order";
// import EditPurchaseOrder from "./purchases-component/purchases/edit-purchase-order";
// import EditPurchaseReturn from "./purchases-component/purchases/edit-purchse-return";
// import SignatureList from "./signature/signature-list";
// import SignatureInvoice from "./signature/signature-invoice";

// import Ledger from "./customers/vendors/ledger";
// import InvoiceThree from "./sales/invoices/Invoice-three";
// import InvoiceTwo from "./sales/invoices/Invoice-two";
// import InvoiceFive from "./sales/invoices/Invoice-five";
// import PurchaseReport from "./reports-component/reports/purchaseReport";
// import PurchaseReturnReport from "./reports-component/reports/purchaseReturnReport";
// import SalesReturn from "./reports-component/reports/salesReturn";
// import QuotationReport from "./reports-component/reports/quotationReport";
// import PaymentReport from "./reports-component/reports/paymentReport";
// import StockReport from "./reports-component/reports/stockReport";
// import LowstockReport from "./reports-component/reports/lowstockReport";
// import IncomeReport from "./reports-component/reports/incomeReport";
// import TaxReport from "./reports-component/reports/taxreport";
// import ExpenseReport from "./reports-component/reports/expenseReport";
// import ProfitLossList from "./reports-component/reports/profitlossReport";
// import CashRecepitOne from "./sales/invoices/cashrecepitone";
// import CashRecepitFour from "./sales/invoices/CashRecepitFour";
// import TwoFactor from "./settings/two-factor";
// import CustomField from "./settings/custom-field";
// import PlanBilling from "./settings/plan-billing";
// import TaxRates from "./settings/tax-rates";
// import SignaturePreviewInvoice from "./signature/signature-preview-invoice";
// import TicketsOpen from "./support/tickets/ticketPending";
// import TicketsResolved from "./support/tickets/ticketOverdue";
// import TicketPending from "./support/tickets/ticketDraft";
// import CashRecepitThree from "./sales/invoices/CashRecepitThree";
// import CashRecepitTwo from "./sales/invoices/CashRecepitTwo";
// import Preferences from "./settings/Preferences";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
// import EditCreditnote from "./sales/creditNotes/edit-creditnote";
// import SassLogin from "./authentication/sass-login";
// import SassRegister from "./authentication/sass-register";
// import EmailTemplates from "./settings/email-templates";
// import SeoSettings from "./settings/seosettings";
// import SaasSettings from "./settings/saassettings";
// import Superdashbord from "./main/superadmin/dashboard";
// import PackagesList from "./main/superadmin/planlist";
// import InvoiceSubscription from "./main/superadmin/invoicesubscription";



import ForgotPassword from "./authentication/ForgotPassword";
import ResetPassword from "./authentication/ResetPassword";
import Logout from "./logout/Index";


import Employee from "./employees/Index";
import EmployeeAdd from "./employees/EmployeeAdd";
import EmployeeEdit from "./employees/EmployeeEdit";
import EmployeeView from "./employees/EmployeeView";

import CnssList from "./cnss/Index";
import EmployeeWorkTime from "./employeeworktime/Index";
import EmployeeWorkTimeDetails from "./employeeworktime/EmployeeWorkTimeDetails";
import EmployeePaySlip from "./employeeworktime/EmployeePaySlip";
import EmployeePaySlipAudit from "./employeeworktime/EmployeePaySlipAudit";


import EmployeeSetting from "./employeesetting/Index";
import EmployeeSettingAdd from "./employeesetting/EmployeeSettingAdd";
import EmployeeSettingEdit from "./employeesetting/EmployeeSettingEdit";

import Customers from "./customers/Index";
import AddCustomer from "./customers/AddCustomer";
import EditCustomer from "./customers/EditCustomer";
import ViewCustomer from "./customers/ViewCustomer";


import Products from "./products/Index";
import AddProduct from "./products/AddProduct";
import ProductListingGroupBY from "./products/ProductListingGroupBY"
import EditProduct from "./products/EditProduct";
import ViewProduct from "./products/ViewProduct";

import Farmers from "./farmers/Index";
import FarmerAdd from "./farmers/FarmerAdd";
import FarmerEdit from "./farmers/FarmerEdit";
import FarmerView from "./farmers/FarmerView";
import Locationtable from "./locations/Index";
import LocationtableAdd from "./locations/LocationtableAdd";
import LocationtableEdit from "./locations/LocationtableEdit";
import LocationView from "./locations/LocationView";
import SmallFarmers from "./smallfarms/Index";
import SmallFarmerAdd from "./smallfarms/SmallFarmerAdd";
import SmallFarmerEdit from "./smallfarms/SmallFarmerEdit";
import SmallFarmerView from "./smallfarms/SmallFarmerView";
import Quality from "./qualities/Index";
import QualityAdd from "./qualities/QualityAdd";
import QualityEdit from "./qualities/QualityEdit";
import QualityView from "./qualities/QualityView";

import QualityReports from "./qualityreports/Index";
import QualityReportsAdd from "./qualityreports/QualityReportsAdd";
import QualityReportsView from "./qualityreports/QualityReportsView";
import QualityReportsEdit from "./qualityreports/QualityReportsEdit";
import QualityReportsAddPallet from "./qualityreports/QualityReportsAddPallet";
import QualityReportPalletEdit from "./qualityreports/QualityReportPalletEdit";


import Orders from "./orders/Index";
import AddOrder from "./orders/AddOrder";
import EditOrder from "./orders/EditOrder";
import ViewOrder from "./orders/ViewOrder";
import ProductionDashboard from "./dashboard/ProductionDashboard";
import ProductionOrders from "./productionorders/Index";
import ViewProductionOrders from "./productionorders/ViewOrder";
import ViewProductionOrdersPlannedDate from "./productionorders/ViewProductionOrdersPlannedDate";
import ProductionOrdersUpdatePlannedDate from "./productionorders/ProductionOrdersUpdatePlannedDate";

import RawMaterial from "./rawmaterial/Index";
import AddRawMaterial from "./rawmaterial/AddRawMaterial";
import EditRawMaterial from "./rawmaterial/EditRawMaterial";
import ViewRawMaterial from "./rawmaterial/ViewRawMaterial";
import ViewAllRawMaterialGroupBy from "./rawmaterial/ViewAllRawMaterialGroupBy";
import ViewAllRawMaterialGroupByLocation from "./rawmaterial/ViewAllRawMaterialGroupByLocation";

import ProductionOutput from "./productionoutput/Index";
import ProductionOutputAdd from "./productionoutput/ProductionOutputAdd";
import ProductionOutputAddEdit from "./productionoutput/ProductionOutputEdit";
import ViewProductionOutput from "./productionoutput/ViewProductionOutput";
import ViewProductionOutputGropyBy from "./productionoutput/ViewProductionOutputGropyBy";
import ViewProductionOutputGropyByPallet from "./productionoutput/ViewProductionOutputGropyByPallet";

import DailyProductionReports from "./dailyproductionreports/Index";
import AddDailyProductionReports from "./dailyproductionreports/AddDailyProductionReports";
import EditDailyProductionReports from "./dailyproductionreports/EditDailyProductionReports";
import ViewDailyProductionReports from "./dailyproductionreports/ViewDailyProductionReports";
import ViewDailyProductionReportsGroupbyfilters from "./dailyproductionreports/ViewDailyProductionReportsGroupbyfilters";
import DailyProductionReportsGroupbyCaliber from "./dailyproductionreports/DailyProductionReportsGroupbyCaliber";
import ProductionFeed from "./productionfeed/Index";
import ProductionFeedAdd from "./productionfeed/ProductionFeedAdd";
import ProductionFeedEdit from "./productionfeed/ProductionFeedEdit";
import ViewProductionFeed from "./productionfeed/ViewProductionFeed";
import ViewProductionFeedGropyBy from "./productionfeed/ViewProductionFeedGropyBy";


import ProductionsInventory from "./productionsinventories/Index";
// import ProductionsInventoryAdd from "./productionsinventories/ProductionsInventoryAdd";
// import ProductionsInventoryEdit from "./productionsinventories/ProductionsInventoryEdit";
import ProductionsInventoryGroupByDateLocation from "./productionsinventories/ProductionsInventoryGroupByDateLocation";
import ProductionsInventoryWeekly from "./productionsinventories/ProductionsInventoryWeekly";




import RawMaterialCreatesFollowUps from "./rawmaterialscratesfollowup/Index";
import RawMaterialCreatesFollowUpsByPlatenumber from "./rawmaterialscratesfollowup/RawMaterialCreatesFollowUpsByPlatenumber";
import RawMaterialCreatesFollowUpsBySupplier from "./rawmaterialscratesfollowup/RawMaterialCreatesFollowUpsBySupplier";


import RawMaterialPricing from "./rawmaterialpricing/Index";
import RawMaterialPricingEdit from "./rawmaterialpricing/RawMaterialPricingEdit";
import RawMaterialPricingView from "./rawmaterialpricing/RawMaterialPricingView";
import ViewAllRawMaterialPricingGroupBy from "./rawmaterialpricing/ViewAllRawMaterialPricingGroupBy";
import ViewAllRawMaterialPricingSupplierGroupBy from "./rawmaterialpricing/ViewAllRawMaterialPricingSupplierGroupBy";

import RawMaterialCabranes from "./rawmaterialscabranes/Index";
// import RawMaterialCabraneAdd from "./rawmaterialscabranes/RawMaterialCabraneAdd";
// import RawMaterialCabraneEdit from "./rawmaterialscabranes/RawMaterialCabraneEdit";

import RawMaterialTransports from "./rawmaterialstransports/Index";
// import RawMaterialTransportAdd from "./rawmaterialstransports/RawMaterialTransportAdd";
// import RawMaterialTransportEdit from "./rawmaterialstransports/RawMaterialTransportEdit";
import SoldesCabranes from "./rawmaterialsoldecabrane/SoldesCabranes";
import SoldesCabranesGroupByView from "./rawmaterialsoldecabrane/SoldesCabranesGroupByView";

import SoldesTransports from "./rawmaterialsoldestansports/SoldesTransports";
import SoldesTransportGroupByView from "./rawmaterialsoldestansports/SoldesTransportGroupByView";

import ProcurementList from "./procurementsupplier/ProcurementList";
import ProcurementSupplierAdd from "./procurementsupplier/ProcurementSupplierAdd";
import ProcurementSupplierEdit from "./procurementsupplier/ProcurementSupplierEdit";



import SoldesSupplier from "./rawmaterialsoldessuppliers/SoldesSupplier";
// import SoldesSupplierGroupByView from "./rawmaterialsoldessuppliers/SoldesSupplierGroupByView";
import SupplierBalanceDetails from "./rawmaterialsoldessuppliers/SupplierBalanceDetails";


import Consumable from "./consumables/Index";
import ConsumableAdd from "./consumables/ConsumableAdd";
import ConsumableEdit from "./consumables/ConsumableEdit";
import ConsumableView from "./consumables/ConsumableView";


import QualityConsumable from "./qualityconsumables/Index";
import QualityConsumableAdd from "./qualityconsumables/QualityConsumableAdd";
import QualityConsumableEdit from "./qualityconsumables/QualityConsumableEdit";
import QualityConsumableView from "./qualityconsumables/QualityConsumableView";

import Supplier from "./suppliers/Index";
import SupplierAdd from "./suppliers/SupplierAdd";
import SupplierEdit from "./suppliers/SupplierEdit";
import SupplierView from "./suppliers/SupplierView";


import FinanceSupplier from "./financessuppliers/Index";
import FinanceSupplierAdd from "./financessuppliers/FinanceSupplierAdd";
import FinanceSupplierEdit from "./financessuppliers/FinanceSupplierEdit";

import SupplyChainLoading from "./supplychainloading/Index";
import AddSupplyChainLoading from "./supplychainloading/AddSupplyChainLoading";
import EditSupplyChainLoading from "./supplychainloading/EditSupplyChainLoading";
import ViewSupplyChainLoading from "./supplychainloading/ViewSupplyChainLoading";

import SupplyChainOrders from "./supplychainorders/Index";
import ViewSupplyChainOrders from "./supplychainorders/ViewOrder";

import StockFollowUp from "./stockfollowups/Index";
import StockFollowUpAdd from "./stockfollowups/StockFollowUpAdd";
import StockFollowUpEdit from "./stockfollowups/StockFollowUpEdit";
import StockFollowUpView from "./stockfollowups/StockFollowUpView";
import StockFollowUpViewByConsumble from "./stockfollowups/StockFollowUpViewByConsumble";
import StockFollowUpViewByLocationDate from "./stockfollowups/StockFollowUpViewByLocationDate";
import StockFollowUpViewByConsumableLocation from "./stockfollowups/StockFollowUpViewByConsumableLocation";
import StockFollowUpViewBySupplierLocation from "./stockfollowups/StockFollowUpViewBySupplierLocation";

import QualityStockFollowUp from "./qualityStockfollowups/Index";
import QualityStockFollowUpAdd from "./qualityStockfollowups/QualityStockFollowUpAdd";
import QualityStockFollowUpEdit from "./qualityStockfollowups/QualityStockFollowUpEdit";
import QualityStockFollowUpView from "./qualityStockfollowups/QualityStockFollowUpView";
import QualityStockFollowUpViewByConsumble from "./qualityStockfollowups/QualityStockFollowUpViewByConsumble";
import QualityStockFollowUpViewByLocationDate from "./qualityStockfollowups/QualityStockFollowUpViewByLocationDate";
import QualityStockFollowUpViewByConsumableLocation from "./qualityStockfollowups/QualityStockFollowUpViewByConsumableLocation";
import QualityStockFollowUpViewBySupplierLocation from "./qualityStockfollowups/QualityStockFollowUpViewBySupplierLocation";



// import StockFollowUpNew from "./stockfollowupsnew/Index";


import StockInventory from "./stockinventories/Index";
import StockInventoryAdd from "./stockinventories/StockInventoryAdd";
import StockInventoryEdit from "./stockinventories/StockInventoryEdit";
import StockInventoryGroupByDateLocation from "./stockinventories/StockInventoryGroupByDateLocation";



import SupplychainPackagelistHeaders from "./supplychainpackagelistheaders/Index";
import SupplychainPackagelistHeadersAdd from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersAdd";
import SupplychainPackagelistHeadersView from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersView";
import SupplychainPackagelistHeadersEdit from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersEdit";

import Localcustomer from "./localcustomers/Index";
import LocalcustomersAdd from "./localcustomers/LocalcustomersAdd";
import LocalcustomersEdit from "./localcustomers/LocalcustomersEdit";



import DecayLoading from "./decayloading/Index";
import DecayLoadingAdd from "./decayloading/DecayLoadingAdd";
import DecayLoadingEdit from "./decayloading/DecayLoadingEdit";
import DecayLoadingView from "./decayloading/DecayLoadingView";




import DecaySale from "./decaysale/Index";
import DecaySaleAdd from "./decaysale/DecaySaleAdd";
import DecaySaleEdit from "./decaysale/DecaySaleEdit";
import DecaySaleGroupbyCustomer from "./decaysale/DecaySaleGroupbyCustomer";
import DecaySaleGroupbyDate from "./decaysale/DecaySaleGroupbyDate";
import DecaySaleView from "./decaysale/DecaySaleView";

import DecayStockFollowUps from "./decaystockfollowups/Index";
import DecayStockFollowUpsView from "./decaystockfollowups/DecayStockFollowUpsView";
import DecayStockFollowUpsWeekly from "./decaystockfollowups/DecayStockFollowUpsWeekly";

import Expenses from "./expenses/Index";
import ExpenseAdd from "./expenses/ExpenseAdd";
import ExpenseEdit from "./expenses/ExpenseEdit";
import ExpenseView from "./expenses/ExpenseView"

import Supplierssituation from "./supplierssituation/Index";
import SupplierssituationDetails from "./supplierssituation/SupplierssituationDetails";



import CaisseEspace from "./caisseespace/Index";
import CaisseEspaceAdd from "./caisseespace/CaisseEspaceAdd";
import CaisseEspaceEdit from "./caisseespace/CaisseEspaceEdit";

import CaisseBank from "./caissebank/Index";
import CaisseBankAdd from "./caissebank/CaisseBankAdd";
import CaisseBankEdit from "./caissebank/CaisseBankEdit";

import ChequeFollowUp from "./chequefollowups/Index";
import ChequeFollowUpAdd from "./chequefollowups/ChequeFollowUpAdd";
import ChequeFollowUpEdit from "./chequefollowups/ChequeFollowUpEdit";


import BankAccountTransaction from "./bankaccounttransaction/Index";
import BankAccountTransactionAdd from "./bankaccounttransaction/BankAccountTransactionAdd";
import BankAccountTransactionEdit from "./bankaccounttransaction/BankAccountTransactionEdit";
import BankAccountTransactionView from "./bankaccounttransaction/BankAccountTransactionView"


import InvoicingCustomerBalance from "./customerbalance/InvoicingCustomerBalance";
import InvoicingCustomerBalanceDetails from "./customerbalance/InvoicingCustomerBalanceDetails";
import InvoicingCustomerBalanceDetailsDashbaord from "./customerbalance/InvoicingCustomerBalanceDetailsDashbaord";



import InvoicingHeaders from "./invoicingheaders/Index";
import AddInvoicingHeaders from "./invoicingheaders/AddInvoice";
import ViewInvoice from "./invoicingheaders/ViewInvoice";
import EditInvoicingHeaders from "./invoicingheaders/EditInvoice";
import EditInvoicingPayment from "./invoicingheaders/EditInvoicingPayment";
import EditInvoicingPaymentAdd from "./invoicingheaders/EditInvoicingPaymentAdd";
import EditInvoicingPaymentEdit from "./invoicingheaders/EditInvoicingPaymentEdit";


import Users from "./users/Index";
import AddUser from "./users/AddUser";
import EditUser from "./users/EditUser";
import ViewUser from "./users/ViewUser";
import PaymentsTerm from "./paymentterms/Index";
import PaymentsTermAdd from "./paymentterms/PaymentsTermAdd";
import PaymentsTermEdit from "./paymentterms/PaymentsTermEdit";

import Season from "./seasons/Index";
import SeasonAdd from "./seasons/SeasonAdd";
import SeasonEdit from "./seasons/SeasonEdit";


import CalledCantacts from "./calledcontacts/Index";
import AddCalledCantacts from "./calledcontacts/AddCalledCantacts";
import EditCalledCantacts from "./calledcontacts/EditCalledCantacts";



import CustomerDashboard from "./customer_role/CustomerDashboard";
import CustomerOrders from "./customer_role/CustomerOrders";
import CustomerOrdersView from "./customer_role/CustomerOrdersView";

import CustomerPackagingSites from "./customer_role/CustomerPackagingSites";
import CustomerPackagingSitesView from "./customer_role/CustomerPackagingSitesView";

import CustomerFarms from "./customer_role/CustomerFarms";
import CustomerFarmsView from "./customer_role/CustomerFarmsView";


import CustomerQualityReports from "./customer_role/CustomerQualityReports";
import CustomerQualityReportsView from "./customer_role/CustomerQualityReportsView";

import CustomerInvoicePayment from "./customer_role/CustomerInvoicePayment";
import CustomerInvoicePaymentDetails from "./customer_role/CustomerInvoicePaymentDetails";
import CustomerInvoiceAllPaymentDetails from "./customer_role/CustomerInvoiceAllPaymentDetails";


import CustomerLoadingView from "./customer_role/CustomerLoadingView";
import CustomerLoading from "./customer_role/CustomerLoading";
import CustomerContacts from "./customer_role/CustomerContacts";

import CustomerLogin from "./customer_role/CustomerLogin";
import CustomerForgotPassword from "./customer_role/CustomerForgotPassword";

import CustomerResetPassword from "./customer_role/CustomerResetPassword";


import CustomerLogout from "./customer_role/CustomerLogout";

import CustomerProfile from "./customer_role/CustomerProfile";

import CustomerProfileSettings from "./customer_role/CustomerProfileSettings";
import CustomerChangePassword from "./customer_role/CustomerChangePassword";
import CustomerUsers from "./customer_role/CustomerUsers";
import CustomerUsersEdit from "./customer_role/CustomerUsersEdit";
import CustomerUsersAdd from "./customer_role/CustomerUsersAdd";




const AppContainer = () => {
  // const config = "/template/react";
  const [showStickySidebar, setShowStickySidebar] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Hide the sidebar on the "/invoices" page
    setShowStickySidebar(
      location.pathname !== "/invoice-one-a" &&
        location.pathname !== "/invoice-two" &&
        location.pathname !== "/invoice-three" &&
        location.pathname !== "/invoice-four-a" &&
        location.pathname !== "/invoice-five" &&
        location.pathname !== "/cashreceipt-1" &&
        location.pathname !== "/cashreceipt-2" &&
        location.pathname !== "/cashreceipt-3" &&
        location.pathname !== "/cashreceipt-4"
    );
  }, [location.pathname]);

  return (
    <Router basename="/">
      {showStickySidebar && <StickySidebar />}
      <Switch>

      <Route path="/logout" component={Logout} />
        <Route path="/index" component={Dashboard} />
        <Route path="/profile" component={Profile} />
        <Route path="/update-profile" component={ProfileSettings} />
        
        <Route path="/change-password" component={ChangePassword} />
        <Route path="/login" exact component={Login} />

        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password/:token" component={ResetPassword} />

          <Route path="/employees" component={Employee} />
          <Route path="/employees-add" component={EmployeeAdd} />
          <Route path="/employees-edit/:id" component={EmployeeEdit} />
          <Route path="/employees-view/:id" component={EmployeeView} />

          <Route path="/cnss" component={CnssList} />
       
          <Route path="/work-time-tracking" component={EmployeeWorkTime} />
          <Route path="/work-time-tracking-view-all/:id" component={EmployeeWorkTimeDetails} />
          
          <Route path="/pay-slip" component={EmployeePaySlip} />
          
          <Route path="/payslip-audit" component={EmployeePaySlipAudit} />
          
          <Route path="/employee-setting" component={EmployeeSetting} />
          <Route path="/employee-setting-add" component={EmployeeSettingAdd} />
          <Route path="/employee-setting-edit/:id" component={EmployeeSettingEdit} />
         
          <Route path="/customers" component={Customers} />
          <Route path="/customers-add" component={AddCustomer} />
          <Route path="/customers-edit/:id" component={EditCustomer} />
          <Route path="/customers-view/:id" component={ViewCustomer} />

          <Route path="/products" component={Products} />
          <Route path="/products-add" component={AddProduct} />
          <Route path="/products-edit/:id" component={EditProduct} />
          <Route path="/products-groupby-name/:id" component={ProductListingGroupBY} />
          <Route path="/products-view/:id" component={ViewProduct} />

          <Route path="/orders" component={Orders} />
          <Route path="/orders-add" component={AddOrder} />
          <Route path="/orders-edit/:id" component={EditOrder} />
          <Route path="/orders-view/:id" component={ViewOrder} />

          <Route path="/farms" component={Farmers} />
          <Route path="/farms-add" component={FarmerAdd} />
          <Route path="/farms-edit/:id" component={FarmerEdit} />
          <Route path="/farms-view/:id" component={FarmerView}  />

          <Route path="/locations" component={Locationtable} />
          <Route path="/locations-add" component={LocationtableAdd} />
          <Route path="/locations-edit/:id" component={LocationtableEdit} />
          <Route path="/locations-view/:id" component={LocationView}  />

          <Route path="/small-farms" component={SmallFarmers} />
          <Route path="/small-farms-add" component={SmallFarmerAdd} />
          <Route path="/small-farms-edit/:id" component={SmallFarmerEdit} />
          <Route path="/small-farms-view/:id" component={SmallFarmerView}  />

          <Route path="/qualities" component={Quality} />
          <Route path="/qualities-add" component={QualityAdd} />
          <Route path="/qualities-edit/:id" component={QualityEdit} />
          <Route path="/qualities-view/:id" component={QualityView} />

          <Route path="/quality-reports" component={QualityReports} />
          <Route path="/quality-reports-add" component={QualityReportsAdd} />
          <Route path="/quality-reports-view/:id" component={QualityReportsView}  />
          <Route path="/quality-reports-edit/:id" component={QualityReportsEdit}  />
          <Route path="/quality-reports-addpallet/:id" component={QualityReportsAddPallet}  />
          <Route path="/quality-reports-editpallet/:id" component={QualityReportPalletEdit}  />


          <Route path="/production-dasboard" component={ProductionDashboard} />
          <Route path="/production-orders" component={ProductionOrders} />
          <Route path="/production-orders-view/:id" component={ViewProductionOrders} />
          
          <Route path="/production-orders-planned-date/:id" component={ViewProductionOrdersPlannedDate} />
          <Route path="/production-orders-update-production-date/:id" component={ProductionOrdersUpdatePlannedDate} />

          <Route path="/raw-materials" component={RawMaterial} />
          <Route path="/raw-materials-add" component={AddRawMaterial} />
          <Route path="/raw-materials-edit/:id" component={EditRawMaterial} />
          <Route path="/raw-materials-view/:id" component={ViewRawMaterial} />
          <Route path="/raw-materials-groupby/:id" component={ViewAllRawMaterialGroupBy} />
          <Route path="/raw-materials-groupbylocation/:id" component={ViewAllRawMaterialGroupByLocation} />

          <Route path="/production-output" component={ProductionOutput} />
          <Route path="/production-output-add" component={ProductionOutputAdd} />
          <Route path="/production-output-edit/:id" component={ProductionOutputAddEdit}/>
          <Route path="/production-output-view/:id" component={ViewProductionOutput}/>
          <Route path="/production-output-groupby/:id" component={ViewProductionOutputGropyBy}/>
          <Route path="/production-output-pallettype/:id" component={ViewProductionOutputGropyByPallet}/>
         
          <Route  path="/production-daily-reports"  component={DailyProductionReports}   />
          <Route  path="/production-daily-reports-add"   component={AddDailyProductionReports}   />
          <Route path="/production-daily-reports-edit/:id"   component={EditDailyProductionReports}  />
          
          <Route  path="/production-daily-reports-view/:id"  component={ViewDailyProductionReports}  />
          <Route  path="/production-daily-reports-groupbyfilters/:id"  component={ViewDailyProductionReportsGroupbyfilters}  />
          <Route  path="/production-daily-reports-groupbycaliber/:id"  component={DailyProductionReportsGroupbyCaliber}  />

          <Route path="/production-feeds" component={ProductionFeed} />
          <Route path="/production-feeds-add" component={ProductionFeedAdd} />
          <Route path="/production-feeds-edit/:id" component={ProductionFeedEdit} />
          <Route path="/production-feeds-view/:id" component={ViewProductionFeed}  />
          <Route path="/production-feeds-groupby/:id" component={ViewProductionFeedGropyBy}/>

          <Route path="/productions-inventories" component={ProductionsInventory} />
          {/* <Route path="/productions-inventories-add" component={ProductionsInventoryAdd} />
          <Route path="/productions-inventories-edit/:id" component={ProductionsInventoryEdit}  /> */}
          <Route path="/productions-inventories-groupby-location-date/:id" component={ProductionsInventoryGroupByDateLocation}  />
          <Route path="/productions-inventories-weekly" component={ProductionsInventoryWeekly}  />
          
          <Route path="/crates-follow-up" component={RawMaterialCreatesFollowUps} />
          <Route path="/crates-follow-up-platenumber/:id" component={RawMaterialCreatesFollowUpsByPlatenumber} />
          <Route path="/crates-follow-up-supplier/:id" component={RawMaterialCreatesFollowUpsBySupplier} />

          <Route path="/raw-material-pricing" component={RawMaterialPricing} />
          <Route path="/raw-material-pricing-edit/:id" component={RawMaterialPricingEdit} />
          <Route path="/raw-material-pricing-view/:id" component={RawMaterialPricingView} />
          <Route path="/raw-material-pricing-groupby/:id" component={ViewAllRawMaterialPricingGroupBy} />
          <Route path="/raw-material-pricing-supplier-groupby/:id" component={ViewAllRawMaterialPricingSupplierGroupBy} />
        
          <Route path="/rawmaterials-cabranes" component={RawMaterialCabranes} />
          {/* <Route path="/rawmaterials-cabranes-add" component={RawMaterialCabraneAdd} />
          <Route path="/rawmaterials-cabranes-edit/:id" component={RawMaterialCabraneEdit} /> */}

          <Route path="/rawmaterials-transports" component={RawMaterialTransports} />
          {/* <Route path="/rawmaterials-transports-add" component={RawMaterialTransportAdd} />
          <Route path="/rawmaterials-transports-edit/:id" component={RawMaterialTransportEdit} /> */}

          <Route path="/cabrane-situation" component={SoldesCabranes} />
          <Route path="/cabrane-situation-groupby/:id" component={SoldesCabranesGroupByView} />
          <Route path="/transport-situation" component={SoldesTransports} />
          <Route path="/transport-situation-groupby/:id" component={SoldesTransportGroupByView} />

          <Route path="/procurementsuppliers" component={ProcurementList} />
          <Route path="/procurementsuppliers-add" component={ProcurementSupplierAdd} />
          <Route path="/procurementsuppliers-edit/:id" component={ProcurementSupplierEdit} />

          <Route path="/supplier-balances" component={SoldesSupplier} />
          {/* <Route path="/supplier-balances-groupby/:id" component={SoldesSupplierGroupByView} /> */}
          <Route path="/supplier-balances-detail/:id" component={SupplierBalanceDetails} />

          <Route path="/consumables" component={Consumable} />
          <Route path="/consumables-add" component={ConsumableAdd} />
          <Route path="/consumables-edit/:id" component={ConsumableEdit} />
          <Route path="/consumables-view/:id" component={ConsumableView}  />

          <Route path="/quality-consumables" component={QualityConsumable} />
          <Route path="/quality-consumables-add" component={QualityConsumableAdd} />
          <Route path="/quality-consumables-edit/:id" component={QualityConsumableEdit} />
          <Route path="/quality-consumables-view/:id" component={QualityConsumableView}  />

          <Route path="/suppliers" component={Supplier} />
          <Route path="/suppliers-add" component={SupplierAdd} />
          <Route path="/suppliers-edit/:id" component={SupplierEdit} />
          <Route path="/suppliers-view/:id" component={SupplierView} />

          <Route path="/financessuppliers" component={FinanceSupplier} />
          <Route path="/financessuppliers-add" component={FinanceSupplierAdd} />
          <Route path="/financessuppliers-edit/:id" component={FinanceSupplierEdit} />

          <Route path="/supplychain-loadings" component={SupplyChainLoading} />
          <Route path="/supplychain-loadings-add"  component={AddSupplyChainLoading} />
          <Route path="/supplychain-loadings-edit/:id"  component={EditSupplyChainLoading}  />
          <Route path="/supplychain-loadings-view/:id" component={ViewSupplyChainLoading}  />

          <Route path="/supplychainorders" component={SupplyChainOrders} />
          <Route path="/supplychainorders-view/:id" component={ViewSupplyChainOrders} />

          <Route path="/supplychain-package-lists" component={SupplychainPackagelistHeaders} />
          <Route path="/supplychain-package-lists-add"  component={SupplychainPackagelistHeadersAdd}  />
          <Route path="/supplychain-package-lists-view/:id" component={SupplychainPackagelistHeadersView} />
          <Route path="/supplychain-package-lists-edit/:id"  component={SupplychainPackagelistHeadersEdit}   /> 

        
          <Route path="/stock-situations" component={StockFollowUp} />
          <Route path="/stock-situations-add" component={StockFollowUpAdd} />
          <Route path="/stock-situations-edit/:id" component={StockFollowUpEdit}/>
          <Route path="/stock-situations-view/:id" component={StockFollowUpView}/>
          <Route path="/stock-situations-viewby-consumable/:id" component={StockFollowUpViewByConsumble}/>

          <Route path="/stock-situations-viewby-location-date/:id" component={StockFollowUpViewByLocationDate}/>
          <Route path="/stock-situations-viewby-consumable-location/:id" component={StockFollowUpViewByConsumableLocation}/>
          <Route path="/stock-situations-viewby-supplier-location/:id" component={StockFollowUpViewBySupplierLocation}/>

         
          <Route path="/quality-stock-situations" component={QualityStockFollowUp} />
          <Route path="/quality-stock-situations-add" component={QualityStockFollowUpAdd} />
          <Route path="/quality-stock-situations-edit/:id" component={QualityStockFollowUpEdit}/>
          <Route path="/quality-stock-situations-view/:id" component={QualityStockFollowUpView}/>
          <Route path="/quality-stock-situations-viewby-consumable/:id" component={QualityStockFollowUpViewByConsumble}/>
          <Route path="/quality-stock-situations-viewby-location-date/:id" component={QualityStockFollowUpViewByLocationDate}/>
          <Route path="/quality-stock-situations-viewby-consumable-location/:id" component={QualityStockFollowUpViewByConsumableLocation}/>
          <Route path="/quality-stock-situations-viewby-consumable-section-location/:id" component={QualityStockFollowUpViewBySupplierLocation}/>

           {/* <Route path="/stock-situations-new" component={StockFollowUpNew} /> */}

          <Route path="/stock-inventories" component={StockInventory} />
          <Route path="/stock-inventories-add" component={StockInventoryAdd} />
          <Route path="/stock-inventories-edit/:id" component={StockInventoryEdit}  />
          <Route path="/stock-inventories-groupby-location-date/:id" component={StockInventoryGroupByDateLocation}  />

      
          <Route path="/decay-loading" component={DecayLoading} />
          <Route path="/decay-loading-add" component={DecayLoadingAdd} />
          <Route path="/decay-loading-edit/:id" component={DecayLoadingEdit} />
          {/* <Route path="/decay-sales-customer/:id" component={DecaySaleGroupbyCustomer} /> */}
          {/* <Route path="/decay-loading-date/:id" component={DecaySaleGroupbyDate} /> */}
          <Route path="/decay-loading-view/:id" component={DecayLoadingView}  />


          <Route path="/local-customers" component={Localcustomer} />
          <Route path="/local-customers-add" component={LocalcustomersAdd} />
          <Route path="/local-customers-edit/:id" component={LocalcustomersEdit} />


          <Route path="/decay-sales" component={DecaySale} />
          <Route path="/decay-sales-add" component={DecaySaleAdd} />
          <Route path="/decay-sales-edit/:id" component={DecaySaleEdit} />
          <Route path="/decay-sales-customer/:id" component={DecaySaleGroupbyCustomer} />
          <Route path="/decay-sales-date/:id" component={DecaySaleGroupbyDate} />
          <Route path="/decay-sales-view/:id" component={DecaySaleView}  />

          <Route path="/decay-stock-follow-ups" component={DecayStockFollowUps} />
          <Route path="/decay-stock-follow-ups-view/:id" component={DecayStockFollowUpsView} />
          <Route path="/decay-stock-follow-ups-weekly" component={DecayStockFollowUpsWeekly}  />

          <Route path="/expenses" component={Expenses} />
          <Route path="/expenses-add" component={ExpenseAdd} />
          <Route path="/expenses-edit/:id" component={ExpenseEdit} />
          <Route path="/expenses-view/:id" component={ExpenseView}  />
          <Route path="/financesuppliersituation" component={Supplierssituation} />
          <Route path="/financesuppliersituation-detail/:id" component={SupplierssituationDetails}  />


          <Route path="/caisse-espece" component={CaisseEspace} />
          <Route path="/caisse-espece-add" component={CaisseEspaceAdd} />
          <Route path="/caisse-espece-edit/:id" component={CaisseEspaceEdit} />
          
          <Route path="/caisse-bank" component={CaisseBank} />
          <Route path="/caisse-bank-add" component={CaisseBankAdd} />
          <Route path="/caisse-bank-edit/:id" component={CaisseBankEdit} />
        
          <Route path="/cheque-follow-ups" component={ChequeFollowUp} />
          <Route path="/cheque-follow-ups-add" component={ChequeFollowUpAdd} />
          <Route path="/cheque-follow-ups-edit/:id" component={ChequeFollowUpEdit} />

          <Route path="/bank-account-transactions" component={BankAccountTransaction} />
          <Route path="/bank-account-transactions-add" component={BankAccountTransactionAdd} />
          <Route path="/bank-account-transactions-edit/:id" component={BankAccountTransactionEdit} />
          <Route path="/bank-account-transactions-view/:id" component={BankAccountTransactionView}  />

          <Route path="/customer-balances" component={InvoicingCustomerBalance} />
          <Route path="/customer-balances-details/:id" component={InvoicingCustomerBalanceDetails} />

          <Route path="/customer-balances-details-customerdasboard/:id" component={InvoicingCustomerBalanceDetailsDashbaord} />

         
          <Route path="/invoices" component={InvoicingHeaders} />
          <Route path="/invoices-add" component={AddInvoicingHeaders} />
          <Route path="/invoices-view/:id" component={ViewInvoice} />
          <Route path="/invoices-edit/:id" component={EditInvoicingHeaders} />
          <Route path="/invoices-payment/:id" component={EditInvoicingPayment} />
          <Route path="/invoices-payment-add/:id" component={EditInvoicingPaymentAdd} />
          <Route path="/invoices-payment-edit/:id" component={EditInvoicingPaymentEdit} />


          <Route path="/users" component={Users} />
          <Route path="/users-add" component={AddUser} />
          <Route path="/users-edit/:id" component={EditUser} />
          <Route path="/users-view/:id" component={ViewUser} />

          <Route path="/payment-terms" component={PaymentsTerm} />
          <Route path="/payment-terms-add" component={PaymentsTermAdd} />
          <Route path="/payment-terms-edit/:id" component={PaymentsTermEdit} />

          <Route path="/called-contacts" component={CalledCantacts} />
          <Route path="/called-contacts-add" component={AddCalledCantacts} />
          
          <Route path="/called-contacts-edit/:id" component={EditCalledCantacts} />

          <Route path="/seasons" component={Season} />
          <Route path="/seasons-add" component={SeasonAdd} />
          <Route path="/seasons-edit/:id" component={SeasonEdit} />


       {/* Customer Routes Start */}
         

  
          <Route path="/customerportal/login" component={CustomerLogin} />
          <Route path="/customerportal/forgot-password" component={CustomerForgotPassword} />
          <Route path="/customerportal/reset-password/:token" component={CustomerResetPassword} />
          <Route path="/customerportal/logout" component={CustomerLogout} />
          
          <Route path="/customerportal/profile" component={CustomerProfile} />
          <Route path="/customerportal/users" component={CustomerUsers} />
          <Route path="/customerportal/users-add" component={CustomerUsersAdd} />
          <Route path="/customerportal/users-edit/:id" component={CustomerUsersEdit} />
          
          <Route path="/customerportal/update-profile" component={CustomerProfileSettings} />
          <Route path="/customerportal/change-password" component={CustomerChangePassword} />


          <Route path="/customerportal/index" component={CustomerDashboard} />
          <Route path="/customerportal/orders" component={CustomerOrders} />
          <Route path="/customerportal/orders-view/:id" component={CustomerOrdersView} />
        
          <Route path="/customerportal/packing-sites" component={CustomerPackagingSites} />
          <Route path="/customerportal/packing-sites-view/:id" component={CustomerPackagingSitesView} />

          <Route path="/customerportal/farms" component={CustomerFarms} />
          <Route path="/customerportal/farms-view/:id" component={CustomerFarmsView} />

          
          <Route path="/customerportal/quality-reports" component={CustomerQualityReports} />
          <Route path="/customerportal/quality-reports-view/:id" component={CustomerQualityReportsView} />
          
      
          <Route path="/customerportal/invoices-payments" component={CustomerInvoicePayment} />
          <Route path="/customerportal/invoices-payments-view/:id" component={CustomerInvoicePaymentDetails} />
          <Route path="/customerportal/invoices-payments-all-view/:id" component={CustomerInvoiceAllPaymentDetails} />
          
      
          <Route path="/customerportal/loadings" component={CustomerLoading} />
          <Route path="/customerportal/loadings-view/:id" component={CustomerLoadingView} />
          <Route path="/customerportal/contacts" component={CustomerContacts} />





          
   {/* Customer Routes End */}

      </Switch>
    </Router>
  );
};

export default AppContainer;
